<style scoped>
.content-wrapper .content {
    padding-top: 95px;
}
.el-select {
    display: block;
}
ul.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
}
ul.bucket-list li.buckets {
    display: inline-block;
    padding: 5px 20px;
    background: #7c6eb8;
    border-radius: 40px;
    margin-right: 10px;
}
ul.bucket-list li.buckets span {
    color: #ffffff;
}
ul.bucket-list li.no-result {
    display: block;
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Update Bucket</h3>
                </div>
                <div class="box-body" v-loading="loading">
                    <form
                        method="post"
                        v-on:submit.prevent="onSubmit"
                        class="form"
                    >
                        <h5>Bucket name</h5>
                        <el-input
                            class=""
                            v-validate="'required'"
                            data-vv-delay="200"
                            :class="{
                                input: true,
                                'is-danger': errors.has('bname'),
                            }"
                            name="bname"
                            type="text"
                            placeholder="Bucket Name"
                            v-model="formData.bname"
                            :disabled="formData.bname == 'default'"
                        ></el-input>
                        <span
                            v-show="errors.has('bname')"
                            class="help is-danger"
                            >{{ errors.first("bname") }}</span
                        >
                        <hr />
                        <!-- <h5>Select Countries</h5>
						<el-select v-model="formData.country" placeholder="Select country" multiple filterable @remove-tag="deleteCountry" @change="countriesChange" :disabled="formData.bname == 'default'">
								<el-option v-for="option in countries" :key="option.id" :label="option.name" :value="option.id" :disabled="existingCountries.indexOf(option.id) > -1 || formData.bname == 'default'">
								</el-option>
						</el-select> -->

                        <!-- 

						<div v-if="formData.isMobile">
							<h5>Select Countries for Mobile Bucket</h5>
						</div>
						<div v-else>
							<h5>Select Countries for Desktop Bucket</h5>
						</div>
						<el-select v-model="formData.country" placeholder="Select country" multiple filterable @remove-tag="deleteCountry" @change="countriesChange" :disabled="formData.bname == 'default'">
							<div v-if="formData.isMobile">
								<el-option v-for="option in countries" :key="option.id" :label="option.name" :value="option.id" :disabled="existingCountriesMobile.indexOf(option.id) > -1 || formData.bname == 'default' || displayexistingCountries.indexOf(option.id) > -1">
								</el-option>
							</div>
							<div v-else>
								<el-option v-for="option in countries" :key="option.id" :label="option.name" :value="option.id" :disabled="existingCountriesDesktop.indexOf(option.id) > -1 || formData.bname == 'default' || displayexistingCountries.indexOf(option.id) > -1">
								</el-option>
							</div>
						</el-select> -->

                        <el-select
                            v-model="formData.country"
                            placeholder="Select country"
                            multiple
                            filterable
                            @remove-tag="deleteCountry"
                            @change="countriesChange"
                            :disabled="formData.bname == 'default'"
                        >
                            <el-option
                                v-for="option in countries"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id"
                                :disabled="
                                    formData.bname == 'default' ||
                                    displayexistingCountries.indexOf(
                                        option.id
                                    ) > -1
                                "
                            >
                            </el-option>
                        </el-select>

                        <hr />
                        <h5>Associate Products</h5>
                        <el-select
                            v-model="formData.prod"
                            placeholder="Select products"
                        >
                            <el-option
                                key=""
                                label="Select a product"
                                value=""
                            ></el-option>
                            <el-option
                                v-for="prod in products"
                                :key="prod.id"
                                :label="prod.name"
                                :value="prod.id"
                            >
                            </el-option>
                        </el-select>
                        <hr />

                        <h5>Bucket features</h5>
                        <div class="row">
                            <!-- <div class="col-md-6" v-for="feature in allFeatues">
								<h5>{{ feature.name }}</h5>
								<el-checkbox v-model="formData.features[feature.name]" :disabled="formData.refresh_all_initially">{{ feature.name }}</el-checkbox>
							</div> -->
                            <div class="col-md-3">
                                <el-checkbox
                                    v-model="formData.refresh_all_after_bids"
                                    :disabled="formData.refresh_all_initially"
                                    >Refresh all units after bids</el-checkbox
                                >
                            </div>
                            <div class="col-md-3">
                                <el-checkbox
                                    v-model="formData.refresh_all_initially"
                                    :disabled="formData.refresh_all_after_bids"
                                    >Refresh all units initially</el-checkbox
                                >
                            </div>
                            <!-- <div class="col-md-3">
                <el-checkbox v-model="formData.FORENSIQ_ANALYSIS"
                  >FORENSIQ_ANALYSIS</el-checkbox
                >
              </div>
              <div class="col-md-3">
                <el-checkbox v-model="formData.FORENSIQ_FIREWALL"
                  >FORENSIQ_FIREWALL
                </el-checkbox>
              </div> -->
                        </div>
                        <hr />
                        <h5>Enable Ad Lightning?</h5>
                        <div class="row">
                            <div class="col-md-3">
                                <el-switch
                                    v-model="formData.ad_lightnings_enable"
                                ></el-switch>
                            </div>
                        </div>
                        <hr />
                        <hr />
                        <h5>Enable Fouanalytics?</h5>
                        <div class="row">
                            <div class="col-md-3">
                                <el-switch
                                    v-model="formData.fouanalytics_enable"
                                ></el-switch>
                            </div>
                        </div>
                        <hr />

                        <h5>Devices</h5>
                        <div class="row">
                            <div class="col-md-3">
                                <el-checkbox
                                    v-model="formData.isMobile"
                                    :disabled="formData.isMobileEnable"
                                    >Mobile enabled?</el-checkbox
                                >
                            </div>
                            <div class="col-md-3">
                                <el-checkbox
                                    v-model="formData.isWeb"
                                    :disabled="formData.isWebEnable"
                                    >Web enabled?</el-checkbox
                                >
                            </div>
                            <div class="col-md-3">
                                <el-checkbox
                                    v-model="formData.isTablet"
                                    :disabled="formData.isTabletEnable"
                                    >Tablet enabled?</el-checkbox
                                >
                            </div>
                            <div
                                class="col-md-6"
                                v-if="formData.messageBCountry"
                            >
                                <p style="color: red">
                                    {{ this.formData.messageBCountry }}
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="clearfix">
                            <el-button @click="onSubmit()" type="success">
                                <i
                                    class="el-icon-left"
                                    :class="{
                                        'el-icon-edit': bucketId !== undefined,
                                        'el-icon-plus': bucketId === undefined,
                                    }"
                                ></i>
                                {{
                                    bucketId === undefined
                                        ? "Create Bucket"
                                        : "Edit Bucket"
                                }}
                            </el-button>

                            <router-link
                                to="/admin/domains/"
                                class="el-button el-button--warning"
                            >
                                Cancel
                            </router-link>

                            <el-dialog
                                :title="dialogue_title"
                                :visible.sync="dialogVisible"
                                width="30%"
                            >
                                <span v-html="confirmation_message"></span>
                                <span slot="footer" class="dialog-footer">
                                    <el-button @click="dialogVisible = false"
                                        >Cancel</el-button
                                    >
                                    <el-button
                                        @click="handleDelete()"
                                        type="primary"
                                        >Confirm</el-button
                                    >
                                </span>
                            </el-dialog>

                            <el-button
                                @click="dialogVisible = true"
                                class="pull-right"
                                type="danger"
                                icon="el-icon-delete"
                                circle
                            ></el-button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>
<script type="text/javascript">
import axios from "axios";
export default {
    data() {
        return {
            confirmation_message:
                "<p>Are you sure that you want to delete this bucket ?</p>",
            dialogue_title: "Are you sure ?",
            dialogVisible: false,
            formData: {
                ad_lightnings_enable: false,
                fouanalytics_enable: false,
                bname: undefined,
                country: [],
                isMobile: true,
                isWeb: true,
                isTablet: true,
                prod: undefined,
                refresh_all_after_bids: false,
                refresh_all_initially: false,
                FORENSIQ_ANALYSIS: false,
                FORENSIQ_FIREWALL: false,

                isMobileEnable: false,
                isWebEnable: false,
                isTabletEnable: false,
                messageBCountry: undefined,
            },
            allFeatues: [],
            bucketId: undefined,
            prod: undefined,
            countries: [],
            checkBucket: [],
            bucketInfoId: undefined,
            domId: undefined,
            uuid: undefined,
            existingCountries: [],
            reapet: false,
            existingCountriesMobile: [],
            existingCountriesDesktop: [],
            existingCountriesTablet: [],
            displayexistingCountries: [],
            products: [],
            assocProd: [],
            loading: true,
            cnm: "",
        };
    },
    created: function () {
        this.uuid = this.$route.params.uuid;
        this.domId = this.$route.params.domId;
        this.bucketId = this.$route.params.bucketId;

        this.copyFormData = JSON.parse(JSON.stringify(this.formData));

        axios
            .all([
                axios.get(
                    BASE_URL +
                        "v1/publishers/" +
                        this.uuid +
                        "/domains/" +
                        this.domId +
                        "/buckets/"
                ),
                axios.get(BASE_URL + "v1/countries/"),
                axios.get(BASE_URL + "v1/products/"),
                axios.get(
                    BASE_URL +
                        "v1/publishers/" +
                        this.uuid +
                        "/domains/" +
                        this.domId +
                        "/buckets/" +
                        this.bucketId +
                        "/"
                ),
            ])
            .then(
                axios.spread((buckets, countriesres, products, bucketInfo) => {
                    this.buckets = buckets.data;
                    this.checkBucket = buckets.data;

                    for (let i = 0; i < this.buckets.length; i++)
                        for (
                            let j = 0;
                            j < this.buckets[i].countries.length;
                            j++
                        ) {
                            if (
                                this.buckets[i].mobile_enabled == true &&
                                this.buckets[i].web_enabled == true && this.buckets[i].tablet_enabled == true
                            ) {
                                this.displayexistingCountries.push(
                                    this.buckets[i].countries[j].id
                                );
                            }
                            if (
                                this.existingCountriesMobile.indexOf(
                                    this.buckets[i].countries[j].id
                                ) == -1 &&
                                this.buckets[i].mobile_enabled
                            ) {
                                this.existingCountriesMobile.push(
                                    this.buckets[i].countries[j].id
                                );
                            } else if (
                                this.existingCountriesDesktop.indexOf(
                                    this.buckets[i].countries[j].id
                                ) == -1 &&
                                this.buckets[i].web_enabled
                            ) {
                                this.existingCountriesDesktop.push(
                                    this.buckets[i].countries[j].id
                                );
                            } else if (this.existingCountriesTablet.indexOf(
                                    this.buckets[i].countries[j].id
                                ) == -1 &&
                                this.buckets[i].tablet_enabled){
                                this.existingCountriesTablet.push(
                                    this.buckets[i].countries[j].id
                                );
                            }
                            if (
                                this.existingCountriesMobile.includes(
                                    this.buckets[i].countries[j].id
                                ) &&
                                this.existingCountriesDesktop.includes(
                                    this.buckets[i].countries[j].id
                                ) &&
                                this.existingCountriesTablet.includes(
                                    this.buckets[i].countries[j].id
                                )
                            ) {
                                this.displayexistingCountries.push(
                                    this.buckets[i].countries[j].id
                                );
                            }
                        }

                    this.countries = countriesres.data;
                    this.products = products.data;

                    if (bucketInfo.data) {
                        var selectedGeo = [];
                        var country=[]
                        var device=[]
                        var i = 0,
                            idx = bucketInfo.data.countries.length;

                        for (; i < idx; i++) {
                            selectedGeo.push(bucketInfo.data.countries[i].id);

                            for (
                                var cb = 0;
                                cb < this.checkBucket.length;
                                cb++
                            ) {
                                if (
                                    this.checkBucket[cb].id !=
                                    bucketInfo.data.id
                                ) {
                                    for (
                                        var ic = 0;
                                        ic <
                                        this.checkBucket[cb].countries.length;
                                        ic++
                                    ) {
                                        if (
                                            bucketInfo.data.countries[i].id ==
                                            this.checkBucket[cb].countries[ic]
                                                .id
                                        ) {
                                            country.push(bucketInfo.data.countries[i]
                                                    .name)
                                            country = Array.from(new Set(country))

                                            this.cnm = country.toString() +
                                                ",";
                                            if (
                                                this.checkBucket[cb].mobile_enabled
                                            ) {
                                                device.push('mobile')
                                                this.formData.isMobileEnable = true;
                                                this.formData.messageBCountry =
                                                    "Country " +
                                                    this.cnm +
                                                    " already used in other bucket as mobile so mobile is disabled";
                                            }
                                            if (
                                                this.checkBucket[cb].web_enabled
                                            ) {
                                                device.push('web')
                                                this.formData.isWebEnable = true;
                                                this.formData.messageBCountry =
                                                    "Country  " +
                                                    this.cnm +
                                                    " already used in other bucket as web so web is disabled";
                                            }
                                            if (
                                                this.checkBucket[cb].tablet_enabled
                                            ) {
                                                device.push('tablet')
                                                this.formData.isTabletEnable = true;
                                                this.formData.messageBCountry =
                                                    "Country  " +
                                                    this.cnm +
                                                    " already used in other bucket as tablet so tablet is disabled";
                                            }
                                            this.formData.messageBCountry ="Country  " +
                                        this.cnm +
                                        " already used in other bucket as "+device+" so "+device+" is disabled";

                                        }
                                    }
                                }
                            }
                        }
                        this.formData.bname = bucketInfo.data.name;
                        this.bucketInfoId = bucketInfo.data.id;
                        this.formData.country = selectedGeo;
                        console.log("bucket information", bucketInfo);
                        this.formData.isMobile = bucketInfo.data.mobile_enabled;
                        this.formData.isWeb = bucketInfo.data.web_enabled;
                        this.formData.isTablet = bucketInfo.data.tablet_enabled;
                        this.formData.prod =
                            bucketInfo.data.product.length > 0 &&
                            bucketInfo.data.product[0].product
                                ? bucketInfo.data.product[0].product.id
                                : undefined;
                        // this.formData.features = bucketInfo.data.features;
                        this.formData.refresh_all_after_bids =
                            bucketInfo.data.features.indexOf(
                                "REFRESH_ALL_UNITS_AFTER_BIDS"
                            ) > -1;
                        this.formData.refresh_all_initially =
                            bucketInfo.data.features.indexOf(
                                "REFRESH_ALL_UNITS_INITIALLY"
                            ) > -1;
                        this.formData.FORENSIQ_FIREWALL =
                            bucketInfo.data.features.indexOf(
                                "FORENSIQ_FIREWALL"
                            ) > -1;
                        this.formData.FORENSIQ_ANALYSIS =
                            bucketInfo.data.features.indexOf(
                                "FORENSIQ_ANALYSIS"
                            ) > -1;
                        console.log(
                            "ad_lightnings_enable in created",
                            bucketInfo.data.ad_lightnings_enable
                        );
                        this.formData.ad_lightnings_enable =
                            bucketInfo.data.ad_lightnings_enable;
                        this.formData.fouanalytics_enable =
                            bucketInfo.data.fouanalytics_enable;
                        this.loading = false;
                    }
                })
            );
    },
    methods: {
        countriesChange(del) {
            console.log("Countries change function@@@@@@@@@@@@", del);
            this.cnm = "";
            this.formData.messageBCountry = undefined;
            this.formData.isWebEnable = false;
            this.formData.isMobileEnable = false;
            this.formData.isTabletEnable = false;
            var isreapetcountry = false;
            var tempiswebEnable = false;
            var tempistabletEnable = false;
            var tempisMobileenable = false;
            this.formData.isWeb = true;
            this.formData.isMobile = true;
            this.formData.isTablet = true;
            var country = []
            var device = []

            for (var i = 0; i < del.length; i++) {
                for (var cb = 0; cb < this.checkBucket.length; cb++) {
                    if (this.checkBucket[cb].id != this.bucketInfoId) {
                        for (
                            var ic = 0;
                            ic < this.checkBucket[cb].countries.length;
                            ic++
                        ) {
                            if (
                                del[i] == this.checkBucket[cb].countries[ic].id
                            ) {
                                isreapetcountry = true;
                                country.push(this.checkBucket[cb].countries[ic].name)
                                country = Array.from(new Set(country))
                                // console.log('oooo',country,this.cnm)

                                this.cnm =
                                    country.toString() +
                                    ",";
                                
                                // console.log('oooo',this.checkBucket[cb])
                                if (this.checkBucket[cb].mobile_enabled) {
                                    device.push('mobile')
                                    tempisMobileenable = true;
                                    this.formData.isMobileEnable = true;
                                    this.formData.isMobile = false;
                                    this.formData.messageBCountry =
                                        "Country " +
                                        this.cnm +
                                        " already used in other bucket as mobile so mobile is disabled";
                                }

                                if (this.checkBucket[cb].web_enabled) {
                                    device.push('web')
                                    tempiswebEnable = true;
                                    this.formData.isWebEnable = true;
                                    this.formData.isWeb = false;
                                    this.formData.messageBCountry =
                                        "Country  " +
                                        this.cnm +
                                        " already used in other bucket as web so web is disabled";
                                }

                                if (this.checkBucket[cb].tablet_enabled) {
                                    device.push('tablet')
                                    tempistabletEnable = true;
                                    this.formData.isTabletEnable = true;
                                    this.formData.isTablet = false;
                                    this.formData.messageBCountry =
                                        "Country  " +
                                        this.cnm +
                                        " already used in other bucket as tablet so tablet is disabled";
                                }
                                this.formData.messageBCountry ="Country  " +
                                        this.cnm +
                                        " already used in other bucket as "+device+" so "+device+" is disabled";
                            }
                        }
                    }
                }

                // if(!isreapetcountry){
                // 		if(this.existingCountriesMobile.includes(del[i])){
                // 				tempiswebEnable=true;
                // 					//this.formData.isWeb=true;
                // 					this.formData.isMobile=false;
                // 			}

                // 		if(this.existingCountriesDesktop.includes(del[i])){
                // 					tempisMobileenable=true;
                // 					this.formData.isWeb=false;
                // 		}
                // }
            }
            // if(tempiswebEnable){

            // 	this.formData.isWebEnable=true;

            // }
            // if(tempisMobileenable){

            // 	this.formData.isMobileEnable=true;
            // }

            // if(this.formData.isMobileEnable == true)
            // {
            //     this.formData.isMobile = false;
            // }
            //     if(this.formData.isWebEnable == true){
            //     this.formData.isWeb = false;
            // }
            console.log(
                "is web ismobile ",
                this.formData.isWeb,
                this.formData.isMobile,
                this.formData.isWebEnable
            );
            if (this.formData.country.length == 0) {
                this.$notify({
                    title: "Warning",
                    message: "Keep at least one country in a bucket",
                    type: "warning",
                });
                return;
            }
        },
        deleteCountry(tag) {
            // console.log(this.formData.country);
            // console.log('DLETING');
            // console.log(tag);
        },
        handleDelete() {
            this.uuid = this.$route.params.uuid;
            this.domId = this.$route.params.domId;
            this.bucketId = this.$route.params.bucketId;

            //console.log(this.uuid, this.domId, this.bucketId);

            if (this.formData.bname == "default") {
                this.dialogue_title = "Default bucket cannot be deleted !";
                this.confirmation_message =
                    '<img class="img-responsive center-block" src="https://i.imgur.com/g6KY4mB.gif"/>';
            } else {
                this.apiLink =
                    BASE_URL +
                    "v1/publishers/" +
                    this.uuid +
                    "/domains/" +
                    this.domId +
                    "/buckets/" +
                    this.bucketId +
                    "/";

                axios
                    .delete(this.apiLink)

                    .then((response) => {
                        //	console.log(response)
                        this.dialogVisible = false;
                        this.buckets_index_url =
                            "/admin/publisher/" +
                            this.uuid +
                            "/domain" +
                            "/edit/" +
                            this.domId;
                        this.$notify({
                            title: "Success",
                            message: "Successfully Deleted the bucket",
                            type: "success",
                        });
                        this.$router.push(this.buckets_index_url);
                    })
                    .catch(function (error) {
                        //console.log(error);
                    });
            }
        },
        onSubmit() {
            let prod = this.formData.prod;

            let payload = {
                    pub_id: this.uuid,
                    domId: this.domId,
                    name: this.formData.bname,
                    domain: this.domId,
                    countries: this.formData.country,
                    mobile_enabled: this.formData.isMobile,
                    web_enabled: this.formData.isWeb,
                    tablet_enabled: this.formData.isTablet
                },
                apiLink = undefined;

            if (
                this.formData.country.length == 0 &&
                this.formData.bname !== "default"
            ) {
                this.$notify({
                    title: "Warning",
                    message: "Keep atleast one country in a buckets",
                    type: "warning",
                });
                return;
            }
            if (
                this.formData.isWeb == false &&
                this.formData.isMobile == false &&
                this.formData.isTablet == false
            ) {
                this.$notify({
                    title: "Warning",
                    message: "Keep atleast one device in a buckets",
                    type: "warning",
                });
                return;
            }

            if (this.bucketId) {
                payload.bucketId = this.bucketId;
            } else
                apiLink =
                    BASE_URL +
                    "v1/publishers/" +
                    this.uuid +
                    "/domains/" +
                    this.domId +
                    "/buckets/";

            // for(let i=0; i<this.formData.country.length; i++)
            // 	if(this.existingCountries.indexOf(this.formData.country[i]) == -1){
            // 		this.existingCountries.push(this.formData.country[i])
            // 	}

            for (let i = 0; i < this.buckets.length; i++) {
                for (let j = 0; j < this.buckets[i].countries.length; j++) {
                    if (
                        this.existingCountriesMobile.indexOf(
                            this.buckets[i].countries[j].id
                        ) == -1 &&
                        this.buckets[i].mobile_enabled
                    ) {
                        this.existingCountriesMobile.push(
                            this.buckets[i].countries[j].id
                        );
                    } else if (
                        this.existingCountriesDesktop.indexOf(
                            this.buckets[i].countries[j].id
                        ) == -1 &&
                        !this.buckets[i].mobile_enabled
                    ) {
                        this.existingCountriesDesktop.push(
                            this.buckets[i].countries[j].id
                        );
                    }
                }
            }
            console.log(
                "ad_lightnings_enable",
                this.formData.ad_lightnings_enable
            );
            let request_obj = {
                ad_lightnings_enable: this.formData.ad_lightnings_enable,
                fouanalytics_enable: this.formData.fouanalytics_enable,
                bucketId: this.bucketId,
                bname: this.formData.bname,
                productAssoc: this.formData.prod,
                refresh_all_initially: this.formData.refresh_all_initially,
                refresh_all_after_bids: this.formData.refresh_all_after_bids,
                FORENSIQ_FIREWALL: this.formData.FORENSIQ_FIREWALL,
                FORENSIQ_ANALYSIS: this.formData.FORENSIQ_ANALYSIS,
                countries: this.formData.country,
                web_enabled: this.formData.isWeb,
                mobile_enabled: this.formData.isMobile,
                tablet_enabled: this.formData.isTablet,
            };

            // for (var feature in this.formData.features) {
            // 	request_obj[feature] = this.formData.features[feature];
            // };

            //console.log(request_obj);
            if (this.formData.prod !== undefined) {
                axios
                    .post(BASE_URL + "v1/update_bucket/", request_obj)
                    .then((response) => {
                        if (response.data.status) {
                            this.$notify({
                                title: "Success",
                                message: response.data.message,
                                type: "success",
                            });
                            this.$router.push(
                                "/admin/publisher/" +
                                    this.uuid +
                                    "/domain/" +
                                    this.domId +
                                    "/buckets/" +
                                    this.bucketId
                            );
                        } else {
                            this.$notify({
                                title: "Warning",
                                message: response.data.message,
                                type: "warning",
                            });
                        }
                    });
            } else {
                this.$notify({
                    title: "Warning",
                    message: "Associate product for the Bucket!",
                    type: "warning",
                });
            }

            // axios.post(apiLink, payload)
            // .then(response => {
            // 	this.formData = JSON.parse(JSON.stringify(this.copyFormData));
            // 	if(this.bucketId){
            // 		// this.
            // 	}
            // 	else{
            // 		// Getting all buckets
            // 		axios.all([
            // 			axios.get(BASE_URL +'v1/publishers/'+ this.uuid +'/domains/'+ this.domId +'/buckets/'),
            // 		])
            // 		.then(axios.spread((buckets) =>  {
            // 			this.buckets = buckets.data;
            // 			for(let i=0; i<this.buckets.length; i++)
            // 				for(let j=0; j<this.buckets[i].countries.length; j++)
            // 					if(this.existingCountries.indexOf(this.buckets[i].countries[j].id) == -1)
            // 						this.existingCountries.push(this.buckets[i].countries[j].id)
            // 			axios.post(BASE_URL + 'v1/publishers/'+ this.uuid +'/domains/'+ this.domId +'/buckets/'+ buckets.data[0].id +'/products/', {
            // 				bucket_id: buckets.data[0].id,
            // 				pub_id: this.uuid,
            // 				domId: this.domId,
            // 				bucket: buckets.data[0].id,
            // 				product: prod,
            // 			})
            // 			.then(response => {
            // 				this.$notify({
            // 					title: 'Success',
            // 					message: 'Successfully created a bucket & associated a product',
            // 					type: 'success'
            // 				});

            // 				setTimeout(() => { this.$router.push('/admin/publisher/'+this.$route.params.uuid+ '/domain/edit/'+this.$route.params.domId); }, 1000);
            // 			})
            // 			.catch(error => {
            // 				this.$notify({
            // 					title: 'Error',
            // 					message: 'Cannot use more than one Product with a Bucket',
            // 					type: 'error'
            // 				});
            // 			});

            // 		}));
            // 	};
            // })
            // .catch(error => {
            // 	this.$notify({
            // 		title: 'Warning',
            // 		message: 'Shit! Something went wrong.',
            // 		type: 'warning'
            // 	});
            // })
        },
    },
};
</script>


// WEBPACK FOOTER //
// BucketDetails.vue?2742fe13